import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import "./index.scss";
import i18next from "i18next";
import { initReactI18next } from "react-i18next";

import faTranslation from "./translation/faTranslation.json";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

i18next.use(initReactI18next).init({
  resources: {
    fa: {
      translation: faTranslation,
    },

    // Add more languages as needed
  },
  lng: "fa", // Set the default language
  fallbackLng: "fa",
  interpolation: {
    escapeValue: false,
  },
});

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
